import { Typography } from '@mui/material'
import React from 'react'

const BodyCard = ({ children }) => {
	return (
		<Typography
			component="div"
			sx={(theme) => ({
				fontSize: 18,
				fontWeight: 400,
				mb: 1,
				[theme.breakpoints.down('md')]: {
					fontSize: 16,
				},
			})}
		>
			{children}
		</Typography>
	)
}

export default BodyCard
